import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { formatDateOnChange, formatStringDateToDate } from "../../../utils/DateUtils";
import { getAlert, getDataWithJoin } from "../../../utils/SamuiUtils";

const LoanCrateReport = () => {
    // ตัวแปรเก็บชื่อหน้าจอ
    const [name, setName] = useState(null);

    // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
    const [searchCriteria, setSearchCriteria] = useState([]);

    // ข้อมูลที่แสดงรายงาน
    const [filteredData, setFilteredData] = useState([]);

    // สำหรับ Table รายงาน
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
        setName("3. รายงานยืมลังประจำวัน");
        setSearchCriteria(
            {
                whDocDate: formatDateOnChange(new Date())
            }
        );
        setFilteredData([]);
    };

    const handleChangeDate = (value, name) => {
        const newValue =
            value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: formatDateOnChange(newValue),
        }));
    };

    const handleSearch = async () => {
        try {
            setFilteredData([]);

            let query = '';

            query += `WHERE WH.Comp_Id = ${window.localStorage.getItem('company')} AND WH.WHDoc_Type = 5 `;

            if (searchCriteria.whDocDate) {
                const formattedDate = formatStringDateToDate(searchCriteria.whDocDate).split(' ')[0];
                query += `AND CONVERT(DATE, WH.WHDoc_Date) = '${formattedDate}' `;
            }

            const response = await getDataWithJoin(
                `
                WH.WHDoc_No, 
                WH.WHDoc_Cust_Code, 
                WH.T_WH_NAME_CHECKDOCTYPE,
                WD.Item_Code,
                WD.Item_Name,
                WD.Item_Qty,
                WD.Item_Unit 
                `,
                `API_1001_WHDOC_H WH`,
                `LEFT JOIN API_1002_WHDOC_D WD ON WD.WHDoc_Id = WH.WHDoc_Id`,
                query.trim()
            );

            if (response && response.length > 0) {
                setFilteredData(response);
            }
        } catch (error) {
            getAlert("FAILED", error.response?.message || error.message);
        }
    };

    return (
        <>
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <Breadcrumbs
                                page={name}
                                items={[
                                    { name: "รายงาน", url: "/reports" },
                                    { name: name, url: "/loan-crate-report" },
                                ]}
                            />
                        </div>
                        <div className="row">
                            {/* Criteria */}
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4>เงื่อนไขการค้นหา</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="row g-3">
                                            <div className="col-md-2">
                                                <label htmlFor="whDocDate" className="form-label">ช่วงวันที่ยืมสินค้า</label>
                                                <Datetime
                                                    id="whDocDate"
                                                    className="input-spacing-input-date"
                                                    value={searchCriteria.whDocDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat={false}
                                                    onChange={(date) => handleChangeDate(date, "whDocDate")}
                                                    inputProps={{ readOnly: true, disabled: false }}

                                                />
                                            </div>
                                            <div className="col-md-3"></div>
                                            <div className="col-md-3"></div>
                                            <div className="col-md-4"></div>
                                            <div className="col-md-12 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', marginRight: '20px', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => handleSearch()}
                                                >
                                                    <i className="fas fa-search" /> ค้นหา
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => initialize()}
                                                >
                                                    <i className="fas fa-undo" /> เริ่มใหม่
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* ReportsTable */}
                            <ReportsTable
                                currentItems={currentItems}
                                currentPage={currentPage}
                                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                dataMasterList={filteredData}
                                itemsPerPage={itemsPerPage}
                                fieldMappings={{
                                    whDocNo: 'WHDoc_No',
                                    tWhCode: 'WHDoc_Cust_Code',
                                    tWhName: 'T_WH_NAME_CHECKDOCTYPE',
                                    itemCode: 'Item_Code',
                                    itemName: 'Item_Name',
                                    itemQty: 'Item_Qty',
                                    itemUnit: 'Item_Unit'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default LoanCrateReport;